import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { APP_API_URL } from '../constants/appURLConstrants';

export default function Login({ setIsAuthenticated }) {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [mustChangePassword, setMustChangePassword] = useState(false);


    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const res = await fetch(`${APP_API_URL}/api/users/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await res.json();

            if (!data.success) {
                setError(data.message || "Login failed");
                return;
            }

            // ✅ Save token + user permanently in localStorage event that the browser is closed or PC is restarted
            // localStorage.setItem("token", data.token);
            // localStorage.setItem("user", JSON.stringify(data.user));

            // ✅ Save token + user in sessionStorage so that it is cleared when the browser tab is closed (more secure than localStorage)
            sessionStorage.setItem("token", data.token);
            sessionStorage.setItem("user", JSON.stringify(data.user));

            setIsAuthenticated(true);
            //navigate("/dashboard");

            // ✅ After login success then check if user must change password and navigate accordingly
            if (data.user.must_change_password) {
                setMustChangePassword(true);
                //navigate("/change-password");

                // Delay redirect so user can see the warning to change password message
                setTimeout(() => {
                    navigate("/change-password",{state: { message: "Your password has been reset. You must change your password before continuing" }});
                }, 1000);
            } else {
                navigate("/dashboard");
            }

        } catch (err) {
            setError("Server error");
        } finally {
            setLoading(false);
        }
    };







    return (
        <div className="login-container">
            {/* LEFT SIDE */}
            <div className="login-left">
                <div className="branding fade-in">
                    {/* <img src="/logo.png" alt="Logo" className="logo" /> */}
                    <img src="AFN2.png" alt="AFN-II Logo" width="360" height="226"></img>
                    <h1 className="lao-title">
                        ລະບົບຈັດການຖານຂໍ້ມູນການຕິດຕາມ ແລະ ປະເມີນຜົນໂຄງການ
                    </h1>
                    <p className="lao-text">
                        ໂຄງການກະສິກຳເພື່ອໂພຊະນາການໄລຍະ 2
                    </p>

                    <h1 className="en-title">
                        M&E Database Management System
                    </h1>
                    <p className="en-text">
                        Agriculture for Nutrition Project - II
                    </p>
                </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="login-right">
                <div className="login-card slide-in">
                    <h2>Welcome</h2>
                    <p>Please login to your account</p>

                    {/* ERROR MESSAGE */}
                    {error && <div className="error">{error}</div>}

                    {/* Show warning message if user must change password */}
                    {mustChangePassword && (
                        <div className="user-login-warning">
                            Your password has been reset.
                            You must change your password before continuing
                        </div>
                    )}

                    <form onSubmit={handleLogin}>
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />

                        {/* PASSWORD FIELD WITH TOGGLE */}
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <span
                                className="toggle"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? "Hide" : "Show"}
                            </span>
                        </div>

                        {/* FORGOT PASSWORD */}
                        <div className="forgot">
                            {/* <a href="#">Forgot password?</a> */}
                        </div>

                        {/* LOGIN BUTTON */}
                        <button type="submit" disabled={loading}>
                            {loading ? <div className="spinner"></div> : "Login"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}